import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import NumberOutput from '../NumberOutput/index.js';
import InformationCardFragments from '../InformationCardFragments/index.js';
import styles from './styles.css.js';

const styleMap = {
  accent: styles.accent,
  complement1: styles.complement1,
  complement2: styles.complement2,
  complement3: styles.complement3
};

function InformationCard(props) {
  const {
    className,
    icon,
    label,
    value,
    variant = 'accent',
    valuePrecision = 0,
    coloredBackground,
    emptyContent = 0
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: _cs(styles.informationCard, className, coloredBackground && styles.coloredBackground, styleMap[variant])
  }, /*#__PURE__*/React.createElement(InformationCardFragments, {
    variant: variant,
    coloredBackground: coloredBackground,
    icon: icon,
    value: /*#__PURE__*/React.createElement(NumberOutput, {
      value: value,
      invalidText: emptyContent,
      precision: valuePrecision
    }),
    label: label,
    labelContainerClassName: styles.labelContainer
  }));
}

var index = genericMemo(InformationCard);

export { index as default };
//# sourceMappingURL=index.js.map
